var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Label, DescriptionLabel, ErrorLabel } from "./label";
import { createControlId } from "./id_creator";
import { getFieldErrorsAsString } from "../validation/validatableentity";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { useif } from "framework/state/types";
import { cls_content, cls_item, cls_input } from "./searchSelect.css";
import { VBox } from "framework/structural_components/hbox_vbox";
import { join } from "framework/helpers";
var searchSelectContext = React.createContext({ onSelect: null, onFilter: null, filter: null });
var Input = React.forwardRef(function (props, ref) {
    var _a = React.useContext(searchSelectContext), filter = _a.filter, onFilter = _a.onFilter, onKeyDown = _a.onKeyDown;
    return React.createElement("input", { className: cls_input, ref: ref, type: "text", tabIndex: 0, value: filter || '', onChange: function (e) { return onFilter(e.target.value); }, onKeyDown: onKeyDown, placeholder: props.placeholder });
});
function SearchSelectItem(props) {
    var onSelect = React.useContext(searchSelectContext).onSelect;
    var onClick = useif(onSelect, function () { return onSelect(props.keyValue); });
    return React.createElement("div", { className: cls_item, onClick: onClick }, props.children);
}
function SearchSelect(props) {
    var _a = React.useState({ filter: null, open: false, editing: false, selectedKey: null, mouseOverFlag: false }), state = _a[0], setState = _a[1];
    var searchInput = React.createRef();
    var id = createControlId();
    var label = props.label, description = props.description;
    var error = props.state ? getFieldErrorsAsString(props.state, props.name) : null;
    React.useEffect(function () {
        var _a;
        if (state.editing) {
            (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [state.editing]);
    var mouseEnter = function () {
        setState(__assign(__assign({}, state), { mouseOverFlag: true }));
    };
    var mouseLeave = function () {
        setState(__assign(__assign({}, state), { mouseOverFlag: false }));
    };
    var editing = function () {
        var _a;
        setState(__assign(__assign({}, state), { filter: (_a = props.selectedValueAsString) !== null && _a !== void 0 ? _a : "", open: true, editing: true, selectedKey: null, mouseOverFlag: false }));
    };
    var onFilter = function (filter) {
        var open = state.open || filter.length > 0;
        setState(__assign(__assign({}, state), { filter: filter, open: open, selectedKey: null }));
        props.onFilter(filter);
    };
    var close = function (key) {
        if (key === void 0) { key = null; }
        setState(__assign(__assign({}, state), { filter: null, open: false, editing: false, selectedKey: null, mouseOverFlag: false }));
        if (props.onSelect) {
            props.onSelect(key);
        }
        props.onFilter(null);
    };
    var justClose = function () {
        if (state.open) {
            if (!state.mouseOverFlag) {
                setState(__assign(__assign({}, state), { filter: null, open: false, editing: false, selectedKey: null }));
                props.onFilter(null);
            }
        }
    };
    var selectNext = function () {
        setState(__assign(__assign({}, state), { selectedKey: null }));
    };
    var selectPrev = function () {
        setState(__assign(__assign({}, state), { selectedKey: null }));
    };
    var onKeyDown = function (e) {
        if (e.keyCode === 27) {
            if (state.open) {
                close();
            }
        }
        else if (e.keyCode === 13) {
        }
        else if (e.keyCode === 38) {
            e.preventDefault();
            if (state.open) {
                selectPrev();
            }
        }
        else if (e.keyCode === 40) {
            e.preventDefault();
            if (state.open) {
                selectNext();
            }
        }
    };
    var id_content = id + '_content';
    React.useEffect(function () {
        var elem = document.getElementById(id_content);
        if (elem) {
            elem.scrollTop = 0;
        }
    }, [props.children]);
    var content_cls = join(props.contentClassName);
    return React.createElement(VBox, { onBlur: function () { return setTimeout(justClose, 100); } },
        React.createElement(searchSelectContext.Provider, { value: { onSelect: close, onFilter: onFilter, filter: state.filter, onKeyDown: onKeyDown } },
            label ? React.createElement(Label, null, label) : React.createElement(React.Fragment, null),
            state.editing
                ? React.createElement(PopoverPrimitive.Root, { open: state.open, modal: false },
                    React.createElement(PopoverPrimitive.Anchor, { asChild: true, tabIndex: 0 },
                        React.createElement(Input, __assign({ ref: searchInput }, props))),
                    React.createElement(PopoverPrimitive.Content, { className: cls_content, onOpenAutoFocus: function (e) { e.preventDefault(); } },
                        React.createElement("div", { onMouseEnter: mouseEnter, onMouseLeave: mouseLeave, className: content_cls, id: id_content }, props.children)))
                : React.createElement("div", { className: cls_input, onClick: editing, onFocus: editing, tabIndex: 0 }, props.keyToTextMapFunc ? props.keyToTextMapFunc(props.selectedValue) : props.selectedValue),
            description ? React.createElement(DescriptionLabel, { htmlFor: id }, description) : React.createElement(React.Fragment, null),
            error ? React.createElement(ErrorLabel, null, error) : React.createElement(React.Fragment, null)));
}
export { SearchSelect, SearchSelectItem, };
